<template>
  <svg width="14"
       height="12"
       viewBox="0 0 14 12"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.83969 -0.000114646C4.44636 -0.093448 1.66636 2.63322 1.66636 5.99989H0.473028C0.173028 5.99989 0.0263615 6.35989 0.239695 6.56655L2.09969 8.43322C2.23303 8.56655 2.43969 8.56655 2.57303 8.43322L4.43303 6.56655C4.4791 6.51956 4.51022 6.45997 4.52248 6.39531C4.53474 6.33066 4.52759 6.26381 4.50193 6.20322C4.47626 6.14262 4.43323 6.09097 4.37826 6.05479C4.32329 6.0186 4.25884 5.9995 4.19303 5.99989H2.99969C2.99969 3.39989 5.1197 1.29989 7.73303 1.33322C10.213 1.36655 12.2997 3.45322 12.333 5.93322C12.3664 8.53988 10.2664 10.6666 7.66636 10.6666C6.59303 10.6666 5.5997 10.2999 4.81303 9.67988C4.68534 9.5793 4.52513 9.52915 4.36287 9.53898C4.20062 9.54882 4.04764 9.61794 3.93303 9.73322C3.65303 10.0132 3.67303 10.4866 3.98636 10.7266C5.03378 11.5549 6.33101 12.0037 7.66636 11.9999C11.033 11.9999 13.7597 9.21988 13.6664 5.82655C13.5797 2.69989 10.9664 0.086552 7.83969 -0.000114646ZM7.49969 3.33322C7.22636 3.33322 6.99969 3.55989 6.99969 3.83322V6.28655C6.99969 6.51989 7.12636 6.73989 7.32636 6.85989L9.40636 8.09322C9.64636 8.23322 9.95303 8.15322 10.093 7.91989C10.233 7.67989 10.153 7.37322 9.91969 7.23322L7.99969 6.09322V3.82655C7.99969 3.55988 7.77303 3.33322 7.49969 3.33322Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    }
  }
}
</script>
